<script setup>
import { ref } from 'vue';
import { useSettingsStore } from '@/stores/settings.store.js';
import HeaderPartial from '@/pages/partials/settings/headerPartial.vue';
import SectionPartial from '@/pages/partials/settings/sectionPartial.vue';

const activeAccount = computed(() => useSettingsStore().activeAccount);
const someoneJoins = ref(false);

const switchHandler = (switchName, isSwitchOn) => {
  // do something here...
};
</script>

<template>
  <div class="tw-max-w-[750px]">
    <headerPartial :title="`${activeAccount.name} Account Notifications`"></headerPartial>
    <!--    <SectionPartial label="Notify me when:" :divider="false">-->
    <!--      <div class="tw-flex tw-flex-col">-->
    <!--        <div class="tw-mb-3 tw-flex tw-items-center tw-justify-between">-->
    <!--          <div class="tw-text-[0.875rem]">Someone joins the team</div>-->
    <!--          <div></div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </SectionPartial>    -->
    <SectionPartial :divider="false">
      <div class="tw-flex tw-flex-col">
        <div class="tw-mb-3 tw-flex tw-items-center tw-justify-between">
          <div class="tw-text-[0.875rem]">Coming Soon...</div>
          <div></div>
        </div>
      </div>
    </SectionPartial>
  </div>
</template>

<style scoped></style>
